<template>
  <div class="footer-bar">
    <div class="w">
      <div class="footer-info">
        <a href="https://www.aiimooc.com/" target="_blank">
          <img src="https://www.aiimooc.com/skin/200061/img/logo-white.png" alt="">
        </a>
      </div>
      <ul class="footer-qa">
        <!-- <li>
          <img src="../../../static/qa1.png" alt="">
          <p>客服微信</p>
          <p>睿慕课-Windy</p>
        </li> -->
        <li>
          <img src="../../../static/qa2.png" alt="">
          <p>关于睿慕课公众号</p>
          <p>获最新职位发布信息</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.footer-bar{
  background-color: #272A30;
  height: 230px;
  .w{
    width: 1000px;
    display: flex;
    justify-content: space-between;
    .footer-info{
      padding-top: 68.5px;
      text-align: center;
      p{
        color: #B4B4B4;
        font-size: 16px;
        line-height: 16px;
      }
    }
    .footer-qa{
      padding-top: 40px;
      li{
        display: inline-block;
        margin-left: 30px;
        width: 158px;
        text-align: center;
        color: #888888;
        font-size: 12px;
        line-height: 19px;
        img{
          margin-bottom: 10.5px;
          width: 104px;
          height: 104px;
        }
      }
    }
  }
}

@media (max-width: 768px){
  .footer-bar{
    background-color: #272A30;
    padding: 0 3%;
    padding-bottom: 30px;
    height: auto;
    width: 100%;
    box-sizing: border-box;
    .w{
      display: block;
      width: 100%;
      .footer-info{
        padding-top: 20px;
        text-align: center;
        img{
          margin-left: -15px;
        }
        p{
          color: #B4B4B4;
          font-size: 14px;
          line-height: 18px;
        }
      }
      .footer-qa{
        padding-top: 24px;
        text-align: center;
        display: flex;
        justify-content: center;
        li{
          display: inline-block;
          margin: 0;
          width: 50%;
          text-align: center;
          color: #888888;
          font-size: 12px;
          line-height: 18px;
          img{
            margin-bottom: 10.5px;
            width: 78px;
            height: 78px;
          }
        }
      }
    }
  }
}
</style>
